import { createEffect, createSignal, onCleanup, type Signal } from "solid-js"
import removeItem from "../../../array/remove_item"
import type { Engine } from "../../../core/engine/Engine.type"
import Unexpected from "../../../Exception/Unexpected.class"
import type { GameObject3DFrameEventFunction } from "./GameObject3DFrameUpdate"

export default function createOnFrameUpdateIsActiveSignal(
  engine: Engine,
  fn: GameObject3DFrameEventFunction,
  start: boolean = false,
): Signal<boolean> {
  const list = engine.ofELL()

  // eslint-disable-next-line solid/reactivity
  const signal = createSignal(start)
  const [isActive] = signal
  createEffect(() => {
    if (isActive()) {
      // console.log('=== Activating')
      if (list.includes(fn)) {
        throw new Unexpected('list.includes(fn)')
      }
      list.push(fn)
    } else {
      // console.log('=== Deactivating')
      removeItem(list, fn)
    }
  })

  onCleanup(() => removeItem(list, fn))

  return signal
}